import { Email as EmailIcon, Google as GoogleIcon, Password as PasswordIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { getSignInErrorDetails } from "../auth/signInErrorDetails";
import { useLoginFlow } from "../auth/useLoginFlow";
import { logLoginEvent } from "../misc/firebase";
import EmailLinkLogin from "./EmailLinkLogin";
import EmailPasswordLogin from "./EmailPasswordLogin";
import SignInSignUpSwitch from "./SignInSignUpSwitch";

const LoginChooser = () => {
  const { mode, setMode, isSigningIn, enqueueLoginError, handleGoogleLogin, handleTravel360Login, handleEmailLogin } =
    useLoginFlow(undefined);

  if (mode === "EMAIL_LINK" || mode === "EMAIL_LINK_CONFIRM") {
    return (
      <SignInSignUpSwitch minWidth="550px">
        <EmailLinkLogin
          isSignInWithEmailLink={mode === "EMAIL_LINK_CONFIRM"}
          onStartLogin={handleEmailLogin}
          onLoginSuccess={() => logLoginEvent("email_link")}
          onLoginFailed={(error) => enqueueLoginError(getSignInErrorDetails(error))}
        />
      </SignInSignUpSwitch>
    );
  }

  if (mode === "EMAIL_PASSOWORD") {
    return (
      <SignInSignUpSwitch minWidth="550px">
        <EmailPasswordLogin
          onLoginSuccess={() => logLoginEvent("email_and_password")}
          onLoginFailed={(error) => enqueueLoginError(getSignInErrorDetails(error))}
        />
      </SignInSignUpSwitch>
    );
  }

  return (
    <SignInSignUpSwitch>
      <Button
        onClick={handleGoogleLogin}
        disabled={isSigningIn}
        fullWidth
        color="primary"
        variant="outlined"
        size="large"
        startIcon={<GoogleIcon />}
      >
        Logowanie Google
      </Button>
      <Button
        onClick={handleTravel360Login}
        disabled={isSigningIn}
        fullWidth
        color="primary"
        variant="outlined"
        size="large"
        startIcon={<GoogleIcon />}
      >
        Logowanie Travel360
      </Button>
      <Button
        onClick={() => setMode("EMAIL_LINK")}
        fullWidth
        color="secondary"
        variant="outlined"
        size="large"
        startIcon={<EmailIcon />}
      >
        Email z linkiem
      </Button>
      <Button
        onClick={() => setMode("EMAIL_PASSOWORD")}
        fullWidth
        color="secondary"
        variant="outlined"
        size="large"
        startIcon={<PasswordIcon />}
      >
        Email i hasło
      </Button>
    </SignInSignUpSwitch>
  );
};

export default LoginChooser;
